import { useState } from "react";

import { api, setToken } from "../lib/api";

/**
 * Exchanges BOOTSTRAP_TOKEN for a device token, exactly the way the Android app will.
 * The token is stored in localStorage; nothing about this flow is web-only.
 */
export default function Enrol({ onEnrolled }: { onEnrolled: () => void }) {
  const [bootstrap, setBootstrap] = useState("");
  const [name, setName] = useState(defaultDeviceName());
  const [existing, setExisting] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function enrol() {
    setBusy(true);
    setError(null);
    try {
      const device = await api.enrol(bootstrap.trim(), name.trim() || "browser");
      setToken(device.token);
      onEnrolled();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  async function useExisting() {
    setBusy(true);
    setError(null);
    setToken(existing.trim());
    try {
      await api.me();
      onEnrolled();
    } catch (err) {
      setToken(null);
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="enrol stack">
      <div>
        <div className="eyebrow">Listing Trawler</div>
        <h1 style={{ fontSize: 26, marginTop: 6 }}>Enrol this device</h1>
        <p className="muted" style={{ fontSize: 14 }}>
          One bearer token per device. Trade your <code>BOOTSTRAP_TOKEN</code> for one, or paste a
          token you already have.
        </p>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="card stack">
        <div className="field">
          <label htmlFor="device-name">Device name</label>
          <input
            id="device-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="desktop"
          />
        </div>
        <div className="field">
          <label htmlFor="bootstrap">Bootstrap token</label>
          <input
            id="bootstrap"
            type="password"
            className="mono"
            value={bootstrap}
            onChange={(e) => setBootstrap(e.target.value)}
            placeholder="from .env"
          />
        </div>
        <button className="primary" disabled={!bootstrap || busy} onClick={enrol}>
          {busy ? "Enrolling..." : "Enrol"}
        </button>
      </div>

      <details>
        <summary className="faint" style={{ cursor: "pointer" }}>
          I already have a device token
        </summary>
        <div className="card stack" style={{ marginTop: 10 }}>
          <input
            className="mono"
            type="password"
            value={existing}
            onChange={(e) => setExisting(e.target.value)}
            placeholder="device token"
          />
          <button disabled={!existing || busy} onClick={useExisting}>
            Use this token
          </button>
        </div>
      </details>
    </div>
  );
}

function defaultDeviceName(): string {
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return "android browser";
  if (/iPhone|iPad/i.test(ua)) return "ios browser";
  if (/Mac/i.test(ua)) return "mac browser";
  return "browser";
}
